import MainLayout from '../../components/MainLayout/MainLayout';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(MainLayout);
